import GuardianService from "../services/guardian-service";

export default class GuardianStorage {
  static #storageKey = 'guardians_list';

  static async update() {
    let response = await GuardianService.all();
    sessionStorage.setItem(this.#storageKey, JSON.stringify(response));
    document.body.dispatchEvent(new Event('guardian-storage-updated'));
  }

  static async get() {
    let value = sessionStorage.getItem(this.#storageKey);

    if (!value) {
      await this.update();
      value = sessionStorage.getItem(this.#storageKey)
    }

    return JSON.parse(value || []);
  }
}